import { SET_DATE } from '../actions/types';

const initialState = {
  startDate: new Date(new Date().getFullYear(), 0, 1),
  endDate: new Date(),
}

const dateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      }
    default:
	    return state
  }
};

export default dateReducer;
